import React, { Component } from 'react';
import 'ant-design-pro/dist/ant-design-pro.css';
import { Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, AutoComplete, message, Modal,Progress,Popover} from 'antd';
import $ from "jquery"
import createHistory from 'history/createHashHistory'
import Result from 'ant-design-pro/lib/Result';
import EventSet from "./../../../assets/PubJs/hcPub"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import logo from "./../../../assets/images/loginLogo1.png"

const history = createHistory();
const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;
const confirm = Modal.confirm;

let _Register = null;
let time = null;
let base = new EventSet.Base64();

class RegistrationForm extends React.Component {
    state = {
        confirmDirty: false,
        autoCompleteResult: [],
        captcha: "获取验证码",
        captDisable: "true",
        phoneExist: false,
        loading: false,
        userFormat: false,
        phoneFormat:false,
        visible:false,
        level:'弱',
        proColor:'#f5222d',
        source:10,
        sourceText:'8-16位，须同时包含字母、数字、符号，区分大小写，请不要使用容易被猜到的密码。'
    };
    componentDidMount() {
        _Register = this;
        time = null;
    }

    //组件卸载时
    componentWillUnmount = () => {
        //清除定时器
        window.clearInterval(time);
    }

    //两次密码判断是否相同
    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不匹配！');
        } else {
            callback();
        }
    }
    validateToNextPassword = (rule, value, callback) => {
        if (!value) {
            callback()
            _Register.setState({
                visible:false,
            })
        }
        else if (/^.*[\u4E00-\u9FA5].*$/.test(value)) {
            callback('密码中不可包含中文')
        }
        else {
            _Register.setState({
                visible:false,
            })
            if (value.indexOf(' ') > -1) {
                callback('密码中不可包含空格');
            }
            else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)(?![\W]+$)(?![0-9a-zA-Z]+$)(?![0-9a-z\W]+$)(?![0-9\W]+$)(?![a-zA-Z\W]+$)[0-9A-Za-z\W]{8,16}$/.test(value)) {
                callback('8-16位，须同时包含字母、数字、符号，区分大小写。');
            }
            else {
                if (EventSet.returnScore(value) < 60) {
                    callback('密码太简单了，请重新设置。');
                }
                else if (sessionStorage.getItem('codeData') && sessionStorage.getItem('codeData').split('臡').indexOf(value) > -1) {
                    callback('密码太简单了，请重新设置。');
                    _Register.setState({
                        proColor:'#f5222d',
                        level:'弱',
                        source:33
                        })
                }
                // else if(value == 'Welcome.1')
                // {
                //     console.log('1072')
                //   callback('不可以设置为初始密码');
                // }
                else {
                    _Register.setState({
                        visible:true,
                    })
                    if(EventSet.returnScore(value)<60){
                        _Register.setState({
                            proColor:'#f5222d',
                            level:'弱',
                            source:33
                        })
                    }else if (EventSet.returnScore(value)>59&&EventSet.returnScore(value)<80){
                        _Register.setState({
                            proColor:'orange',
                            level:'中',
                            source:66
                        })
                    }else{
                        _Register.setState({
                            proColor:'#52c41a',
                            level:'强',
                            source:99
                        })
                    }
                    callback();
                }
            }
        }
    }
    //两次密码判断是否相同

    //获取验证码
    getCaptcha = () => {
        if (!_Register.state.phoneExist) {

            
            $.ajax({
                url: "https://webservice.jshcsoft.com/SSMSAPI/sendmessage.ashx",
                type: "post",
                data: {
                    tele: _Register.props.form.getFieldValue("phone"),
                    type: 'jiangsu'
                },
                async: false,
                success: function (res) {
                    // EventSet.setCookie("captcha", base.encode(num), "m5");

                    if (res.indexOf("true") >= 0) {
                        message.success("验证码发送成功");
                        localStorage.setItem("captchaPhoneNum", _Register.props.form.getFieldValue("phone"))

                        _Register.setState({
                            captcha: "60s",
                            captDisable: "true"
                        }, () => {
                            var timer = 60;
                            time = setInterval(function () {
                                timer--;
                                _Register.setState({
                                    captcha: timer + "s"
                                }, () => {
                                    if (timer == 0) {
                                        window.clearInterval(time);
                                        time = null;
                                        _Register.setState({
                                            captcha: "获取验证码",
                                            captDisable: ""
                                        })
                                    }
                                })
                            }, 1000)
                        })
                    } else {
                        message.error("验证码发送失败");
                    }
                }
            })
        }
    }

    //已有账号登录
    login = () => {
        history.push({ pathname: '/Login/LoginMain/LoginEntry', })
    }

    //注册
    resgister = () => {
        _Register.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                _Register.setState({
                    visible: false
                })
              

                        setTimeout(function () {
                            //注册
                            $.ajax({
                                url: Hcurl + "/user/Register",
                                type: "post",
                                headers: {
                                    "token": EventSet.getUserInfo()['token']
                                },
                                data: {
                                    userName: values.username,
                                    passWord: values.password,
                                    linkPhone: values.phone,
                                    validCode: values.captcha
                                },
                                success: function (res) {
                                    _Register.setState({
                                        loading: false
                                    })

                                    //注册失败
                                    if (res.indexOf("false") >= 0) {
                                        Modal.confirm({
                                            title: res.split('|')[1],
                                            content: '',
                                            okText: '知道了',
                                            onOk() {

                                            }
                                        });
                                    } else {
                                        //注册成功的结果展示修改
                                        _Register.setState({
                                            visible: false
                                        })
                                        _App.setState({
                                            register: "none",
                                            registerResult: "block",
                                            registerWidth: "550px",
                                            registerName: values.username
                                        })

                                        localStorage.setItem("username", values.username);
                                        localStorage.removeItem("captcha");
                                    }
                                },
                                error: function (res) {
                                    Modal.confirm({
                                        title: '服务器出错，请稍后重试',
                                        content: '',
                                        okText: '知道了',
                                        cancelText: '取消',
                                        onOk() {

                                        }
                                    });
                                }
                            })
                        }, 100)
                    
                    }else{
                        _Register.setState({
                            visible: false
                        })
                    }  
            
        });
    }

    //判断用户名是否存在
    usernameTest = () => {
        // if (_Register.props.form.getFieldValue("username") != undefined && _Register.props.form.getFieldValue("username") != "") {
        //     if (!this.state.userFormat) {
        //         $.ajax({
        //             url: Hcurl + "/user/VaildUserName",
        //             type: "post",
        //             headers: {
        //                 "token": EventSet.getUserInfo()['token']
        //             },
        //             data: {
        //                 userName: _Register.props.form.getFieldValue("username")
        //             },
        //             async: false,
        //             success: function (res) {

        //                 if (res.indexOf("false") >= 0) {
        //                     Modal.warning({
        //                         title: '此用户名已存在，请更换一个！',
        //                         content: '',
        //                         okText: '知道了',
        //                         onOk() {
        //                             _Register.props.form.setFieldsValue({
        //                                 username: ""
        //                             })
        //                         }
        //                     });
        //                 }
        //             },
        //             error: function () {
        //                 //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
        //             }
        //         })
        //     }
        // }
    }

    //失去焦点判断手机号是否存在
    phoneTest = () => {
        if (_Register.props.form.getFieldValue("phone") != undefined && _Register.props.form.getFieldValue("phone") != "") {
            if (!this.state.phoneFormat) {
                $.ajax({
                    url: Hcurl + "/user/VaildLinkPhone",
                    type: "post",
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    data: {
                        linkPhone: _Register.props.form.getFieldValue("phone")
                    },
                    async: false,
                    success: function (res) {

                        if (res.indexOf("false") >= 0) {
                            _Register.setState({
                                phoneExist: true
                            })
                            Modal.warning({
                                title: '该手机号码已注册，您可以前往登录页面直接登录！',
                                content: '',
                                okText: '知道了',
                                onOk() {
                                    _Register.props.form.setFieldsValue({
                                        phone: ""
                                    })
                                }
                            });
                        } else {
                            _Register.setState({
                                phoneExist: false
                            })
                        }
                    },
                    error: function () {
                        //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    }
                })
            }
        }
    }

    //验证手机号格式
    phoneInputTest = (rule, value, callback) => {
        if (value != undefined && value != "" && value != null) {
            let reg = /^1[0-9]{10}$/;
            if (reg.test(value) == false) {
                callback("手机号格式不正确");
                _Register.setState({
                    captDisable: "true",
                    phoneFormat:true
                })
            } else {
                callback();
                if (time == null) {
                    _Register.setState({
                        captDisable: "",
                        phoneFormat: false
                    })
                }
            }
        } else {
            callback();
            _Register.setState({
                captDisable: "true",
                phoneFormat: true
            })
        }
    }

    //验证用户名格式
    userTest = (rule, value, callback) => {
        if (value != undefined && value != "" && value != null) {
            // /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
            // /^[a-zA-Z][a-zA-Z0-9]{3,15}$/
            // let reg = /^(?![0-9]+$)\w{6,20}$/;
            let reg = /[\x21-\x7e]{6,20}/;
            
            // (?!\d+$)[\dA-Za-z_]{6,20}
            
            // let reg = /^[a-zA-Z_]([_a-zA-Z0-9]{3,19})+$/;
            if (reg.test(value) == false) {
                callback("6~20位，仅限字母、数字、符号，不包含空格！")
                this.setState({
                    userFormat:true
                })
            } else {
                callback();
                this.setState({
                    userFormat: false
                })
            }
        } else {
            callback();
            this.setState({
                userFormat: true
            })
        }
    }

    //验证验证码
    captchaTest = (rule, value, callback) => {
        // if (value != undefined && value != "" && value != null) {
        //     if (value.length == 5) {
        //         if (base.decode(EventSet.getCookie("captcha")) != _Register.props.form.getFieldValue("captcha")) {
        //             callback("验证码错误");
        //         } else {
        //             callback();
        //         }
        //     } else {
        //         callback("验证码错误");
        //     }
        // } else {
            callback()
        // }
    }

    //keyup = () => {
    //    _Register.props.form.setFieldsValue({
    //        password: _Register.props.form.getFieldValue("password").replace(/\s+/g, '')
    //    })
    //}
    blur=()=>{
        _Register.setState({
            visible:false,
           
        })
      }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { autoCompleteResult } = this.state;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 24,
                    offset: 0,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit}>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('username', {
                        rules: [{
                            required: true, message: '请设置用户名!',
                        }, {
                            validator: this.userTest,
                        }],
                    })(
                        <Input placeholder="请设置用户名" size="large" maxLength="20" onBlur={this.usernameTest}/>
                        )}
                </FormItem>
                <Popover
                            placement="rightTop"
                            content={<div style={{width:'290px',padding:'10px 10px'}}>
                                <p style={{color:this.state.proColor,marginBottom:'0'}}>强度：{this.state.level}</p>
                                <Progress strokeColor={this.state.proColor} percent={this.state.source} showInfo={false} />
                                <p style={{marginBottom:'0'}}>{this.state.sourceText}</p>
                            </div>}
                            title="密码强度"
                            trigger="click"
                            visible={this.state.visible}
                        >
                <div></div>
                </Popover>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码！',
                        }, { validator: this.validateToNextPassword}],
                    })(
                        <Input onBlur={this.blur} type="password" placeholder="8-16位，须同时包含字母、数字、符号" size="large" maxLength="16" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '请确认密码！',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input  type="password" onBlur={this.handleConfirmBlur} placeholder="确认密码" size="large" maxLength="16" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('phone', {
                        rules: [{
                            required: true, message: '请输入手机号码!'
                        }, {
                            validator: this.phoneInputTest,
                        }],
                    })(
                        <Input placeholder="11位手机号，可用于登录和找回密码" size="large" maxLength="11" onBlur={this.phoneTest} />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    <Row gutter={8}>
                        <Col span={16}>
                            {getFieldDecorator('captcha', {
                                rules: [
                                    {
                                        required: true, message: '请输入验证码！'
                                    }, {
                                    validator: this.captchaTest,
                                }],
                            })(
                                <Input maxLength="6" placeholder="请输入验证码" size="large" />
                                )}
                        </Col>
                        <Col span={8}>
                            <Button size="large" onClick={this.getCaptcha} style={{ width: "115px" }} disabled={this.state.captDisable}> { this.state.captcha }</Button>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout}
                >
                    <Row>
                        <Col span={12}>
                            <Button type="primary" htmlType="submit" size="large" style={{ width: "100%" }} onClick={this.resgister} loading={this.state.loading}>注册</Button>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <a onClick={this.login}>使用已有帐户登录</a>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm);


let _App = null;
class App extends Component {
    state = {
        register: "block",
        registerResult: "none",
        registerWidth: "368px",
        registerName:""
    }
    login = () => {
        history.push({ pathname: '/Login/LoginMain/LoginEntry', })
    }
    componentDidMount() {
        _App = this;
    }

    render() {
        return (
            <div className="LoginWrap">
                <div className="LoginTitle">
                    <div style={{ width: this.state.registerWidth, margin: "0 auto", marginTop: 80 }}>
                        <p style={{ textAlign: "center", fontSize: "22px",color:"#333" }}>
                            <img src={logo} alt="" style={{width:"40%"}} />
                            智慧315先行和解平台
                        </p>
                        <div style={{ display: this.state.register }}>
                            <div style={{ lineHeight: "65px", fontSize: "18px", color: "#000" }}>注册</div>
                            <WrappedRegistrationForm />
                        </div>
                        <Result
                            type="success"
                            title={<div style={{ color: '#000' }}>你的帐户：{this.state.registerName}注册成功</div>}
                            description={<div style={{ color: '#ccc' }}>您的账户已注册成功，您可以通过下方“前往登录”按钮跳转至登录页面进行账号登录。</div>}
                            actions={<Button type="primary" size="large" onClick={this.login}>前往登录</Button>}
                            style={{ display: this.state.registerResult }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Login/Register/Register.js